/* Banky Nieuw WP5.1: gedrag van de servicepagina's (PLAN.md #55, #57). Alleen wat de HTML niet zelf kan; zonder
   JavaScript staat alle inhoud gewoon op de pagina.
   1. Servicehub (/pages/faq, snippet banky-service-hub): live zoeken in de vragen en de koopgidsen (alleen in de pagina,
      geen zoek-URL), lege staat en statusregel voor schermlezers; het onderwerp in beeld krijgt aria-current in de
      navigatie.
   2. Retour (/pages/retour, sectie banky-return-portal): de stappenbalk volgt de stap in beeld; "Direct retour aanmelden"
      zet de focus op de kop van het formulier (was de {% javascript %} van de sectie); "Hier de overeenkomst herroepen"
      (anker #herroepen, ronde Geert 01-10, G1) doet hetzelfde, ook bij binnenkomst via de footer.
   Reviews (/pages/reviews) hebben geen eigen gedrag nodig: filters, sortering en bladeren blijven A's banky-review-list
   (assets/banky-sales.js). */
(() => {
  if (window.bankyService) return;
  window.bankyService = true;
  const stil = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Onderwerp in beeld: het laatste element waarvan de bovenkant boven de leeslijn ligt.
  function volgInBeeld(links, doelen, zet) {
    if (!doelen.length) return;
    let bezig = false;
    const kies = () => {
      bezig = false;
      const lijn = window.innerHeight * 0.3;
      let actief = null;
      for (const d of doelen) { if (!d.hidden && d.getBoundingClientRect().top - lijn <= 0) actief = d; }
      zet(actief || doelen.find(d => !d.hidden) || null);
    };
    window.addEventListener('scroll', () => { if (!bezig) { bezig = true; requestAnimationFrame(kies); } }, {passive: true});
    window.addEventListener('resize', kies);
    kies();
  }

  // 1. Servicehub
  document.querySelectorAll('[data-banky-hub]').forEach(hub => {
    const invoer = hub.querySelector('[data-banky-hub-zoek]');
    const status = hub.querySelector('[data-banky-hub-status]');
    const leeg = hub.querySelector('[data-banky-hub-leeg]');
    const groepen = [...hub.querySelectorAll('[data-banky-hub-groep]')];
    const vragen = [...hub.querySelectorAll('details.banky-hub__vraag')];
    const gidsen = [...hub.querySelectorAll('[data-banky-hub-gids]')];
    const norm = t => (t || '').toLocaleLowerCase('nl').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim();
    const teksten = new Map([...vragen, ...gidsen].map(el => [el, norm(el.textContent)]));
    const tekst = (n) => n === 1 ? hub.dataset.eenGevonden : (hub.dataset.gevonden || '').replace('{{ aantal }}', n);
    const filter = () => {
      const woorden = norm(invoer.value).split(' ').filter(Boolean);
      const past = el => woorden.every(w => teksten.get(el).includes(w));
      let aantal = 0;
      for (const v of vragen) { const ok = !woorden.length || past(v); v.hidden = !ok; if (ok) aantal++; }
      for (const g of gidsen) g.hidden = woorden.length > 0 && !past(g);
      for (const groep of groepen) groep.hidden = ![...groep.querySelectorAll('details.banky-hub__vraag, [data-banky-hub-gids]')].some(el => !el.hidden);
      const niets = woorden.length > 0 && !groepen.some(g => !g.hidden);
      if (leeg) leeg.hidden = !niets;
      if (status) status.textContent = woorden.length && !niets ? tekst(aantal) : '';
      // Eindronde service-content (01-10-2026): zolang er een zoekterm is, wijken de vier servicetegels (CSS
      // .banky-hub.is-zoekend), zodat de gevonden vragen of "Geen vraag gevonden" direct onder het zoekveld staan.
      hub.classList.toggle('is-zoekend', woorden.length > 0);
      hub.querySelectorAll('[data-banky-hub-nav] a[href^="#"]').forEach(a => {
        const doel = hub.querySelector(a.getAttribute('href'));
        const li = a.closest('li'), weg = !!doel && doel.hidden; if (li.hidden !== weg) li.hidden = weg;
      });
    };
    // Na 300 ms rust: valt de eerste treffer (of de lege melding) buiten het zichtbare deel, bijvoorbeeld onder het
    // toetsenbord van een telefoon, dan schuift het zoekveld naar boven (onder de kop, scroll-margin in CSS), met de
    // uitkomst er direct onder.
    let rust = 0;
    const inBeeld = () => {
      const doel = [...vragen, ...gidsen].find(el => !el.hidden && el.offsetParent) || (leeg && !leeg.hidden ? leeg : null);
      if (!doel || !invoer.value.trim()) return;
      const zicht = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      const r = doel.getBoundingClientRect();
      if (r.top >= 0 && Math.min(r.bottom, r.top + 120) <= zicht) return;
      (invoer.closest('.banky-hub__zoek') || invoer).scrollIntoView({behavior: stil ? 'auto' : 'smooth', block: 'start'});
    };
    if (invoer) {
      invoer.addEventListener('input', () => { clearTimeout(rust); rust = setTimeout(inBeeld, 300); });
      invoer.addEventListener('input', filter);
      invoer.addEventListener('keydown', e => { if (e.key === 'Escape' && invoer.value) { invoer.value = ''; filter(); } });
    }
    const nav = [...hub.querySelectorAll('[data-banky-hub-nav] a[href^="#"]')];
    volgInBeeld(nav, groepen, actief => nav.forEach(a => a.setAttribute('aria-current', actief && a.getAttribute('href') === '#' + actief.id ? 'true' : 'false')));
    nav.forEach(a => a.addEventListener('click', e => {
      const doel = hub.querySelector(a.getAttribute('href'));
      if (!doel) return;
      e.preventDefault();
      doel.scrollIntoView({behavior: stil ? 'auto' : 'smooth', block: 'start'});
      history.replaceState(null, '', a.getAttribute('href'));
    }));
  });

  // 2. Retour: stappenbalk
  document.querySelectorAll('[data-banky-retour]').forEach(portaal => {
    const stappen = [...portaal.querySelectorAll('[data-banky-retour-stap]')];
    const doelen = stappen.map(a => portaal.querySelector(a.getAttribute('href'))).filter(Boolean);
    volgInBeeld(stappen, doelen, actief => stappen.forEach(a => {
      const aan = !!actief && a.getAttribute('href') === '#' + actief.id;
      a.closest('li').classList.toggle('is-actief', aan);
      if (aan) a.setAttribute('aria-current', 'step'); else a.removeAttribute('aria-current');
    }));
    const naarFormulier = () => {
      const kop = portaal.querySelector('#banky-return-form');
      requestAnimationFrame(() => kop?.focus({preventScroll: true}));
    };
    portaal.addEventListener('click', e => {
      if (e.target.closest('a[href="#banky-return-form"], a[href="#banky-retour-aanmelden"]')) naarFormulier();
    });
    // Ronde Geert 01-10 (G1, c4): "Hier de overeenkomst herroepen" (bovenaan deze pagina en in de footer van elke pagina,
    // /pages/retour#herroepen) leidt direct naar het formulier en slaat stap 1 over: de focus gaat naar de formulierkop,
    // bij een klik op deze pagina en bij binnenkomst vanaf een andere pagina.
    document.addEventListener('click', e => {
      const link = e.target.closest('a[href$="#herroepen"]');
      if (link && link.pathname === location.pathname) naarFormulier();
    });
    if (location.hash === '#herroepen') naarFormulier();
  });

})();
